AgrimarketServices.service('agrimasterApiService', ['$rootScope', '$http', '$location', 'configurationFactory',
    function ($rootScope, $http, $location, configurationFactory) {

        var SendRequest = function (configfile, callback) {
            $http(configfile)
                .success(function (data) {
                    callback(data, null, null, null);
                })
                .error(function (data, status, headers, config) {
                    callback(data, status, headers, config);
                });
        };

        this.GetOffersAgrimaster = function (idCrop, idProduct, idTypeOffer, callback) {
            var config = {
                method: 'get',
                url: configurationFactory.Url['Api'] + 'AgrimasterApi/GetOffersAgrimaster',
                params: {
                    idCrop: idCrop,
                    idProduct: idProduct,
                    idTypeOffer: idTypeOffer
                }
            };

            SendRequest(config, callback);
        };

        this.GetStrikesAgrimaster = function (idCrop, idProduct, idExpiryWsd, idTypeOption, callback) {
            var config = {
                method: 'get',
                url: configurationFactory.Url['Api'] + 'AgrimasterApi/GetStrikesAgrimaster',
                params: {
                    idCrop: idCrop,
                    idProduct: idProduct,
                    idExpiryWsd: idExpiryWsd,
                    idTypeOption: idTypeOption
                }
            };

            SendRequest(config, callback);
        };

    }]);